import { LicenseTrialSubFormWebComponent } from './component/LicenseTrialSubFormWebComponent';
import { WEB_COMPONENT_LICENSE_TRIAL_SUBFORM } from '../../webcomponents.constants';

export { LicenseTrialSubFormWebComponent };

window.customElements.define(WEB_COMPONENT_LICENSE_TRIAL_SUBFORM, LicenseTrialSubFormWebComponent);
